import React from 'react';
import { Navigate } from 'react-router-dom';

import { Flex } from 'ui/Layout';
import Separator from 'ui/Separator';

import Page from '../../components/Page';
import CustomerApproachedSankeysLimitBanner from '../../components/banners/CustomerApproachedSankeysLimitBanner';
import CustomerExceededSankeysLimitBanner from '../../components/banners/CustomerExceededSankeysLimitBanner';
import CustomerReachedSankeysLimitBanner from '../../components/banners/CustomerReachedSankeysLimitBanner';
import NonCustomerExceededSankeysLimitBanner from '../../components/banners/NonCustomerExceededSankeysLimitBanner';
import NonCustomerReachedSankeysLimitBanner from '../../components/banners/NonCustomerReachedSankeysLimitBanner';
import NonCustomerSankeySlotAwardedBanner from '../../components/banners/NonCustomerSankeySlotAwardedBanner';
import { useAppEnvironmentContext } from '../../contexts/appEnvironmentContext';
import { useOfficeContext } from '../../utils/addin/office';
import { Path } from '../../utils/routes';
import { useCurrentUser } from '../../utils/user';
import AddinHomePageFooter from './AddinHomePageFooter';
import AddinSavedDiagramsButton from './AddinSavedDiagramsButton';
import BrandingLead from './BrandingLead';
import CreateFromExcelDataButton from './CreateFromExcelDataButton';
import CreateFromTemplateButton from './CreateFromTemplateButton';
import HomePageSignUpLink from './HomePageSignUpLink';
import TryDemoDiagramButton from './TryDemoDiagramButton';

const AddinHomePage: React.FC = () => {
  const { appEnvironment } = useAppEnvironmentContext();
  const { isExcel } = useOfficeContext();
  const { user } = useCurrentUser();

  // If a web user ends up here, redirect them to the Sankeys overview page
  if (appEnvironment === 'web') {
    return <Navigate to={Path.Sankeys} replace />;
  }

  return (
    <Page>
      <Flex direction="column">
        <NonCustomerSankeySlotAwardedBanner />
        <NonCustomerReachedSankeysLimitBanner />
        <NonCustomerExceededSankeysLimitBanner />
        <CustomerApproachedSankeysLimitBanner />
        <CustomerReachedSankeysLimitBanner />
        <CustomerExceededSankeysLimitBanner />
      </Flex>
      <Flex
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        flex={1}
        gap={4}
      >
        <BrandingLead />
        {!user ? (
          <>
            <TryDemoDiagramButton />
            <HomePageSignUpLink />
          </>
        ) : (
          <>
            {isExcel && <CreateFromExcelDataButton />}
            <CreateFromTemplateButton />
            <Separator w="100px" my="5px" />
            <AddinSavedDiagramsButton />
          </>
        )}
      </Flex>
      {user && <AddinHomePageFooter />}
    </Page>
  );
};

export default AddinHomePage;
